import React from "react";
import {NewsSectionCreateDto, NewsSectionDto} from "../../api";
import {Input} from "antd";
import {CrudForm, CrudFormItemProps, nameof} from "digimuth-components/dist";
import BeeftekaFileUploader from "../components/fileUploader/beeftekaFileUploader";

const {TextArea} = Input;

export default function NewsSectionForm(props: NewsSectionFormProps) {
    const initialValues = props.initialValues;
    const formItems: CrudFormItemProps[] = [
        {
            name: nameof<NewsSectionCreateDto>("imageId"),
            label:"Zdjęcie",
            children: <BeeftekaFileUploader
                accept="image/jpeg,image/png"
                sizeLimitMb={6}
                defaultFile = {initialValues?.imageId ? {
                    uid: initialValues?.imageId!.toString(),
                    name: initialValues?.image?.fileName || "",
                    originFileObj: (initialValues?.image as any).originFileObj
                } : undefined}
                useOrganisationFileApi={true}
                isFilePublic={true}
            />,
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ],
        },
        {
            name: '',
            children: <h2>Nowości</h2>
        },
        {
            name: nameof<NewsSectionCreateDto>("newsTitle"),
            rules: [
            ],
            label: "Tytuł"
        },
        {
            name: nameof<NewsSectionCreateDto>("newsDescription"),
            rules: [
            ],
            label: "Opis",
            children: <TextArea/>
        },
        {
            name: nameof<NewsSectionCreateDto>("newsUrl"),
            rules: [
            ],
            label: "Link"
        },
        {
            name: '',
            children: <h2>Wydarzenia</h2>
        },
        {
            name: nameof<NewsSectionCreateDto>("eventTitle"),
            rules: [
            ],
            label: "Tytuł"
        },
        {
            name: nameof<NewsSectionCreateDto>("eventDescription"),
            rules: [
            ],
            label: "Opis",
            children: <TextArea/>
        },
        {
            name: nameof<NewsSectionCreateDto>("eventUrl"),
            rules: [
            ],
            label: "Link"
        }
    ];

    return <>
        {props.initialValues !== null ?
            <CrudForm
                formItems={formItems}
                onSubmit={props.onSubmit}
                saveButtonTitle="Zapisz"
                initialValues={props.initialValues}
            /> : null}
    </>
}

interface NewsSectionFormProps {
    initialValues: NewsSectionDto | null,
    onSubmit: (name: NewsSectionDto) => Promise<any>,
}
